import { createContext as reactCreateContext } from 'react';

export default function createContext(name = '', initialValue = undefined) {
    const Context = reactCreateContext(initialValue);
    Context.displayName = `${name}Context`;

    return Context;
}
